import React from 'react';

import BaseLogo from './sourceImages/logo.svg';

export default function Logo (params) {
    return (
        <img src={BaseLogo} alt="SocialBoterfly Logo" />
    )
    
}